/**
 * The list remembers the stock value a user last toggled, so a quick second tap and a failed save can
 * be told apart from the saved value. Once fresh rows arrive from the server they are the truth: forget
 * the remembered value for every product shown, unless its own save is still in flight.
 */
export function forgetSettledStock(
  docs: Array<{ _id?: string }>,
  pending: Record<string, boolean>,
  ...caches: Array<Record<string, boolean>>
): void {
  for (const doc of docs) {
    const id = doc?._id;
    if (!id || pending[id]) continue;
    for (const cache of caches) delete cache[id];
  }
}

/**
 * A reload can answer with the stock a product had before a toggle that is still being saved. Keep the
 * toggled value on screen for those products, so the switch does not jump back and the next tap still counts.
 */
export function applyPendingStock<T extends { _id?: string }>(
  rows: T[],
  pending: Record<string, boolean>,
  shown: Record<string, boolean>
): T[] {
  return rows.map((row) =>
    row?._id && pending[row._id] && shown[row._id] !== undefined ? { ...row, inStock: shown[row._id] } : row
  );
}
